<template>
	<div id="app">
		<uiPreload v-if="!loaded" />

		<keep-alive>
			<router-view class="page" v-if="loaded" />
		</keep-alive>

		<Navigation v-if="loaded" />

		<!-- <div class="confirm-holder" v-if="confirm">
			<div class="confirm-bg" @click="onConfirmClick(false)" />
			<div class="confirm-inner">
				<div class="confirm-title">{{ confirm }}</div>
				<div class="confirm-buttons">
					<uiButton
						class="confirm-btn"
						color="grey"
						@click="onConfirmClick(false)"
					>
						Неа
					</uiButton>
					<uiButton class="confirm-btn" @click="onConfirmClick(true)">
						Ага
					</uiButton>
				</div>
			</div>
		</div> -->

		<div class="modal-holder" v-if="confirm">
			<ConfirmView
				:text="confirm"
				@close="confirm = null"
				@result="onConfirmClick"
			/>
		</div>

		<div class="modal-holder" v-if="imageviewer">
			<ImageViewer :content="imageviewer" @close="imageviewer = null" />
		</div>

		<div class="modal-holder" v-if="videoviewer">
			<VideoViewer v-bind="videoviewer" @close="videoviewer = null" />
		</div>

		<div class="modal-holder" v-if="pdfViewer">
			<PDFViewer :content="pdfViewer" @close="pdfViewer = null" />
		</div>

		<div class="notificator" :class="{ visible: showNotif }">
			{{ notification }}
		</div>
	</div>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/messaging'
import Events from '@/utils/events'
import { API, FIREBASE } from '@/config'
import Navigation from '@/components/Navigation'
import ImageViewer from '@/components/ImageViewer'
import VideoViewer from '@/components/VideoViewer'
import PDFViewer from '@/components/PDFViewer'
import ConfirmView from '@/components/ConfirmView'

export default {
	name: 'App',
	components: {
		Navigation,
		ImageViewer,
		VideoViewer,
		PDFViewer,
		ConfirmView,
	},
	data() {
		return {
			loaded: false,
			saving: false,
			showNotif: false,
			order: null,
			notification: null,
			notifications: [],
			timemout: null,
			confirm: false,
			imageviewer: null,
			videoviewer: null,
			pdfViewer: null,
		}
	},
	computed: {
		user() {
			return this.$store.getters.user
		},
		navTitle() {
			return 'Центральная'
		},
	},
	watch: {
		$route(route) {
			this.validateRoute(route)
		},
	},
	async mounted() {
		let { data } = await this.$http.get(API.AUTH.check)
		if (!data || data.err) {
			this.$router.replace('/auth').catch(() => {})
			this.loaded = true
			return
		}

		this.$store.commit('setUser', data)

		if (!this.user) {
			this.loaded = true
			return this.$router.replace('/auth').catch(() => {})
		}

		if (!this.nowInterval) {
			this.nowInterval = setInterval(() => {
				this.$store.commit('setNow')
			}, 1000)
		}

		// if (!this.ordersInterval) {
		// 	this.ordersInterval = setInterval(() => {
		// 		this.$store.dispatch('syncOrders')
		// 	}, 1000 * 60 * 5)
		// }

		let valid = this.validateRoute()

		await this.$store.dispatch('loadInitialData')
		// if (!valid) return

		await this.$pusher.connect()

		let messaging
		let pushEnabled
		try {
			firebase.initializeApp(FIREBASE.config)
			messaging = firebase.messaging()
			let token = await messaging.getToken({ vapidKey: FIREBASE.pushKey })
			if (token) {
				pushEnabled = true
				let exist = this.user.webTokens.includes(token)
				if (!exist) {
					let payload = {
						uuid: 'admin',
						platform: 'web',
						token: token,
					}
					await this.$http.post(API.AUTH.pushToken, payload)
				}
			}
		} catch (err) {
			console.log('error init firebase')
			console.log(err)
		}

		if (pushEnabled) {
			let registration = await navigator.serviceWorker.getRegistration(
				'/firebase-cloud-messaging-push-scope'
			)
			messaging.onMessage(payload => {
				let options = {
					body: payload.notification.body,
					icon: payload.notification.icon,
				}
				registration.showNotification(
					payload.notification.title,
					options
				)
				Events.$emit('push-message', payload)
			})
		}

		Events.$on('app-saving', e => (this.saving = e))
		Events.$on('notification', this.showNotification)
		Events.$on('confirm', this.showConfirm)
		Events.$on('imageViewer', this.showImageViewer)
		Events.$on('videoViewer', this.showVideoViewer)
		Events.$on('pdfViewer', this.showPDFViewer)

		// pusher events
		Events.$on('callMutation', payload => {
			this.$store.commit(payload.mutation, payload.payload)
		})

		Events.$on('chatMessage', payload => {
			this.$store.dispatch('fetchChatMessage', payload)
		})

		Events.$on('fetchTicket', payload => {
			this.$store.dispatch('fetchTicket', payload)
		})

		Events.$on('updateChatAndTicket', payload => {
			this.$store.dispatch('updateChatAndTicket', payload)
		})

		Events.$on('deleteChatAndTicket', payload => {
			this.$store.dispatch('deleteChatAndTicket', payload)
		})

		Events.$on('fetchCall', payload => {
			this.$store.dispatch('fetchCall', payload)
		})

		Events.$on('startTyping', payload => {
			this.$store.commit('setTypingUser', payload)
		})

		Events.$on('stopTyping', payload => {
			this.$store.commit('removeTypingUser', payload)
		})

		Events.$on('chatUpdateMessage', payload => {
			this.$store.commit('updateMessage', payload)
		})

		Events.$on('chatDeleteMessage', payload => {
			this.$store.commit('deleteMessage', payload)
		})

		Events.$on('chatDeleteMessage', payload => {
			this.$store.commit('deleteMessage', payload)
		})

		Events.$on('chatUpdateReadBy', payload => {
			this.$store.commit('updateReadBy', payload)
		})

		// window.addEventListener('focus', (e) => this.$store.dispatch('syncOrders'))
		window.onbeforeunload = () => {
			if (this.saving) return 'Секунду, мы сохраняемся'
		}

		this.loaded = true

		if (this.user && this.$route.path === '/auth') {
			return this.$router.replace('/')
		}
	},
	methods: {
		validateRoute(route) {
			if (!this.user) return
			let r = route || this.$route
			if (r.meta && r.meta.roles) {
				let valid = false
				if (this.$isGod()) valid = true
				this.user.roles.forEach(role => {
					if (r.meta.roles.includes(role)) valid = true
				})
				if (!valid) return this.$router.push('/')
			}
		},
		pageSelected(page) {
			return this.$route.name === page
		},
		showNotification(e, time = 3000) {
			if (this.timemout) return this.notifications.push(e)
			this.timemout = true

			this.notification =
				e || 'Глебас так накодил, что ничего не работает'
			this.showNotif = true
			this.timeout = setTimeout(() => {
				clearTimeout(this.timemout)
				this.timemout = null
				this.showNotif = false
				if (this.notifications.length) {
					let next = this.notifications.shift()
					this.showNotification(next)
				}
			}, time)
		},
		showConfirm(e, next) {
			this.confirm = e
			this.confirmNext = next
		},
		showImageViewer(e) {
			if (!Array.isArray(e)) e = [e]
			this.imageviewer = e
		},
		showVideoViewer(e) {
			this.videoviewer = e
		},
		showPDFViewer(e) {
			this.pdfViewer = e
		},
		onConfirmClick(result) {
			this.confirmNext(result)
			this.confirmNext = null
			this.confirm = null
		},
		openOrder(e) {
			this.order = e
		},
	},
}
</script>

<style lang="less">
@import './assets/app.less';
@import './assets/lineicons.css';
@import './assets/csshake.css';

* {
	unicode-bidi: plaintext;
}

body {
	padding: 0;
	margin: 0;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	background: @bg;
	font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen,
		Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
}

.page {
	width: 100vw;
	height: calc(100vh - 50px);
	margin-top: 50px;
	// position: fixed;
}

a {
	color: @accent;
	text-decoration: none;
}

h2 {
	padding: 0;
	margin: 0;
	margin-bottom: 5px;
}

h3 {
	padding: 0;
	margin: 0;
	margin-bottom: 5px;
	font-size: 18px;
	font-weight: 600;
}

.global-id {
	font-size: 11px !important;
	opacity: 0.3 !important;

	&:before {
		content: 'id: ';
	}
}

.global-medialog {
	font-size: 11px !important;
	opacity: 0.3 !important;

	&:before {
		content: 'medialog id: ';
	}
}

.profile {
	height: 60px;
	font-size: 18px;
	position: absolute;
	right: 10px;
	top: 10px;
	overflow: hidden;
	z-index: 5;
	background: #000;
	border-radius: 10px;
	border: 1px solid transparent;

	&.open {
		height: auto;
		border: 1px solid rgba(255, 255, 255, 0.3);
	}

	.inner {
		height: auto;
	}

	.row {
		display: flex;
		justify-content: flex-end;
		align-items: center;
		height: 40px;
		padding: 20px;
		cursor: pointer;

		&.login {
			.button {
				width: 100px;
			}
		}

		img {
			width: 40px;
			height: 40px;
			border-radius: 25px;
			display: block;
			margin-left: 10px;
		}
	}
}

.notificator {
	position: absolute;
	top: 15px;
	left: 50%;
	background: #000;
	color: #fff;
	padding: 10px 15px;
	border-radius: 10px;
	transition: all 300ms ease;
	transform: translateX(-50%) translateY(-200%);
	box-shadow: 0 0 60px rgba(255, 255, 255, 0.5);
	z-index: 50;

	&.visible {
		transform: translateX(-50%) translateY(0);
	}
}

.modal-holder {
	width: 100vw;
	height: 100vh;
	top: 0;
	left: 0;
	position: fixed;
	overflow: hidden;
	background: rgba(0, 0, 0, 0.8);
	display: flex;
	justify-content: center;
	align-items: center;
	z-index: 30;
}
</style>
